import MuiLinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import linearProgressHelper from "src/helpers/linearProgressHelper";

class LinearProgress extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      visibility: false
    };
  }

  componentDidMount() {
    linearProgressHelper.registerLinearProgress(this);
  }

  componentWillUnmount() {
    linearProgressHelper.unregisterLinearProgress();
  }

  setVisibility(visibility) {
    this.setState({
      visibility: visibility
    });
  }

  render() {
    const { classes } = this.props;
    const { visibility } = this.state;

    return <MuiLinearProgress className={visibility ? "" : classes.dNone} />;
  }
}

const styles = {
  dNone: {
    display: "none"
  }
};

export default withStyles(styles)(LinearProgress);
